import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const GET_RATE_INFOS = createRequestTypes('placement/RATE_INFO/GET_RATE_INFOS');
export const SORT_RATE_INFOS = createRequestTypes('placement/RATE_INFO/SORT_RATE_INFOS');

export const getRateInfos = {
  request: (params) => createAction(GET_RATE_INFOS[REQUEST], { params }),
  success: (response, params) => createAction(GET_RATE_INFOS[SUCCESS], { response, params }),
  failure: (response) => createAction(GET_RATE_INFOS[FAILURE], { response }),
};
export const sortRateInfos = {
  request: (params) => createAction(SORT_RATE_INFOS[REQUEST], { params }),
  success: (response, params) => createAction(SORT_RATE_INFOS[SUCCESS], { response, params }),
  failure: (response) => createAction(SORT_RATE_INFOS[FAILURE], { response }),
};
